var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCases(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13524_147282)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75045 1.5H14.0005V1.89699e-06H2.00046V1.5H7.25045L7.25045 12.664L3.50046 13.599V12.2654C4.51473 11.9469 5.25046 10.9993 5.25046 9.87988C5.25046 8.49917 4.13117 7.37988 2.75046 7.37988C1.36974 7.37988 0.250456 8.49917 0.250456 9.87988C0.250456 10.9993 0.986179 11.9469 2.00046 12.2654V13.973L0.0566406 14.4576L0.419523 15.9131L15.9443 12.0423L15.5814 10.5869L14.0005 10.9811V9.63555C15.0147 9.31698 15.7505 8.36941 15.7505 7.25C15.7505 5.86929 14.6312 4.75 13.2505 4.75C11.8697 4.75 10.7505 5.86929 10.7505 7.25C10.7505 8.36941 11.4862 9.31698 12.5005 9.63555V11.3551L8.75045 12.29V1.5ZM13.2505 6.25C13.8027 6.25 14.2505 6.69772 14.2505 7.25C14.2505 7.80229 13.8027 8.25 13.2505 8.25C12.6982 8.25 12.2505 7.80229 12.2505 7.25C12.2505 6.69772 12.6982 6.25 13.2505 6.25ZM2.75046 8.87988C3.30274 8.87988 3.75046 9.3276 3.75046 9.87988C3.75046 10.4322 3.30274 10.8799 2.75046 10.8799C2.19817 10.8799 1.75046 10.4322 1.75046 9.87988C1.75046 9.3276 2.19817 8.87988 2.75046 8.87988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13524_147282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCases);
export default __webpack_public_path__ + "static/media/cases.9f1d5ebac5c3ed9c064e5fbab2a1d969.svg";
export { ForwardRef as ReactComponent };